"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidUri = exports.isStringWithLength = void 0;
var isStringWithLength = function isStringWithLength(val) {
  return val !== null && val !== undefined && !Number.isNaN(val) && Object.prototype.toString.call(val) === '[object String]' && val.length > 0;
};
exports.isStringWithLength = isStringWithLength;
var isValidUri = function isValidUri(val) {
  try {
    new URL(val);
    return true;
  } catch (err) {
    return false;
  }
};
exports.isValidUri = isValidUri;